import React from 'react';

import { AddressActions } from './address-validation-link';
import { AddressValidationStatusContainer } from './address-validation-status-container';
import { useHasFulfillmentPlanRestriction } from '../../../../restrictions-context';
import { UiRestrictions } from '../../../../../../../enums/component-states';
import { FlagAddressButton } from '../../../../../flag-address/flag-address-button';
import { useEnableLossPrevention } from '../../../../../../../feature-flags/hooks/use-enable-loss-prevention';
import { useFulfillmentPlanIdContext } from '../../../../../../../fulfillment-plans/context/fulfillment-plan-id-context-provider';

export const AddressValidationSection = () => {
  const isRestricted = useHasFulfillmentPlanRestriction(UiRestrictions.ShipTos);
  const isLossPreventionEnabled = useEnableLossPrevention();
  const fulfillmentPlanId = useFulfillmentPlanIdContext();

  if (isRestricted) {
    return null;
  }

  return (
    <>
      <AddressValidationStatusContainer />
      <AddressActions />
      {isLossPreventionEnabled && <FlagAddressButton fulfillmentPlanId={fulfillmentPlanId} />}
    </>
  );
};
